import { forEach } from 'lodash'

/**
 * A simple MessageBag type wrapper for objects, especially
 * useful for digesting validation error messages from
 * Laravel validators that look like:
 * { errors: { foo: [ 'bar', 'ding' ], field2: [ ... ], ... } }
 * @param {[type]} contents The error response
 */
let MessageBag = function (contents) {
  this.contents = contents || {}
  if (typeof this.contents === 'string') {
    let parsed = JSON.parse(this.contents)
    if (parsed.errors) {
      this.contents = parsed.errors
    } else {
      this.contents = parsed
    }
  }
}

MessageBag.fromResponse = function (xhr) {
  let bag = new MessageBag()
  if (xhr.response.data && xhr.response.data.errors) {
    bag.contents = xhr.response.data.errors
  }
  return bag
}

MessageBag.prototype.mapToVm = function (vm, scope) {
  return forEach(this.contents, (errors, field) => {
    vm.errors.add({
      field,
      msg: errors[0],
      scope,
    })
  })
}

/**
 * Get the first error in the bag, either in the
 * entire bag, or in a given field.
 * @param  String field Optionally, test one specific field
 * @return String An error message
 */
MessageBag.prototype.first = function (field) {
  if (!this.contents) {
    return false
  }

  var keys = Object.keys(this.contents)
  if (keys.length) {
    if (field) {
      var error = this.contents[field]
      return error && error.length ? error[0] : false
    } else {
      return keys.length && keys[0].length ? this.contents[keys[0]][0] : false
    }
  } else {
    return false
  }
}

/**
 * Are there any errors in the bag and/or specific field?
 * @param String field Optionally, test one specific field
 * @return bool
 */
MessageBag.prototype.has = function (field) {
  return !!this.first(field)
}

export {
  MessageBag
}

export default (contents) => {
  return new MessageBag(contents)
}
